// Dev-only workbench harness — /dev-workbench mounts the REAL repair
// docket outside AuthWrapper so Playwright (and the CTO) can drive it
// without OAuth, same contract as /dev-chat. Query params pick the
// target: /dev-workbench?course=<id>&domain=<key>. STRICTLY development:
// CRA inlines NODE_ENV, so production bundles compile this to nothing.
import React, { useState } from 'react';

import WorkbenchPanel from './workbench/WorkbenchPanel';

export default function DevWorkbench() {
  const [closed, setClosed] = useState(false);
  if (process.env.NODE_ENV !== 'development') return null;

  const params = new URLSearchParams(window.location.search);
  const courseId = params.get('course');
  const domain = params.get('domain');

  if (!courseId || !domain) {
    return (
      <div style={{ padding: 24, fontFamily: 'monospace', fontSize: 13 }}>
        dev-workbench harness — pass ?course=&lt;id&gt;&amp;domain=&lt;key&gt;
      </div>
    );
  }
  if (closed) {
    return (
      <div style={{ padding: 24, fontFamily: 'monospace', fontSize: 13 }}>
        repair set aside — reload to start another.
      </div>
    );
  }
  return (
    <div data-testid="dev-workbench" style={{ minHeight: '100vh' }}>
      <WorkbenchPanel
        courseId={courseId}
        domain={domain}
        onClose={() => setClosed(true)}
      />
    </div>
  );
}
